import i18n from '@/i18n';
import { MODEL_STUDIO_NAV_IDS } from '@/pages/ipe/workbench/constants/modelStudioConfig';
import { IMAGE_FISSION_VARIATION_COUNT_OPTIONS } from '@/pages/ipe/workbench/constants/imageFissionStudioConfig';
import { buildAspectSizeApiPayload } from '@/pages/ipe/workbench/constants/imageFissionAspectSize';

const PARAMS_PANEL_NAV_IDS = new Set([
  'smartCutout',
  'imageEnhance',
  'aiOutpaint',
  'img2img',
  'imageFission',
  'patternFission',
  ...MODEL_STUDIO_NAV_IDS,
  'infringementDetection',
  'podProductDesign',
]);

/** 是否在快捷弹窗内展示参数面板（否则只显示 cardDesc） */
export function detailToolBridgeHasParamsPanel(navId) {
  return PARAMS_PANEL_NAV_IDS.has(String(navId || '').trim());
}

/** 是否套用功能页工作室壳样式（--studio / --img2img / --pod） */
export function detailToolBridgeUsesStudioShell(navId) {
  return detailToolBridgeHasParamsPanel(navId);
}

/**
 * 确认前参数校验。
 * @returns {{ ok: boolean, message?: string }}
 */
export function validateDetailToolBridgeParams(navId, studioParams = {}) {
  const id = String(navId || '').trim();
  const sp = studioParams && typeof studioParams === 'object' ? studioParams : {};

  if (id === 'img2img') {
    if (!String(sp.prompt || '').trim()) {
      return { ok: false, message: i18n.t('workbench:ipeUtilError.needEditInstruction') };
    }
  }
  if (id === 'podProductDesign') {
    const ids = (Array.isArray(sp.imageTemplateIds) ? sp.imageTemplateIds : [])
      .map(String)
      .filter(Boolean);
    if (ids.length === 0) {
      return { ok: false, message: i18n.t('workbench:ipeUtilError.needDesignTemplate') };
    }
  }
  if (id === 'imageFission' || id === 'patternFission') {
    const aspectRatio = String(sp.aspectRatio || 'original');
    if (aspectRatio !== 'original') {
      const w = Math.floor(Number(sp.outputWidth) || 0);
      const h = Math.floor(Number(sp.outputHeight) || 0);
      if (!w || !h) {
        return { ok: false, message: i18n.t('workbench:ipeUtilError.needOutputSize') };
      }
    }
  }
  return { ok: true };
}

/** 图片裂变 / 图案裂变：把弹窗 studioParams 映射为 createBatch API 字段 */
export function resolveFissionBridgeApiPayload(studioParams = {}) {
  const sp = studioParams && typeof studioParams === 'object' ? studioParams : {};
  const variationCountRaw = Number(sp.variationCount);
  const variationCount = IMAGE_FISSION_VARIATION_COUNT_OPTIONS.includes(variationCountRaw)
    ? variationCountRaw
    : 1;
  return {
    variationCount: Math.min(4, Math.max(1, variationCount)),
    patternOnly: sp.patternOnly === true,
    ...buildAspectSizeApiPayload({
      aspectRatio: sp.aspectRatio,
      outputWidth: sp.outputWidth,
      outputHeight: sp.outputHeight,
    }),
  };
}
